import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function TestimonialsSection() {
  const fadeIn = useFadeIn();
  const testimonials = [{
    initials: 'SM',
    quote: "My 6-year-old asks me every morning to do his brain pages. His teacher even commented on how much more focused he's been in class. I never expected something printable to make this kind of difference.",
    author: 'Sarah M.',
    location: 'Mom of 2',
    badge: null
  }, {
    initials: 'JT',
    quote: "My daughter went from shutting down the second things got hard — to pushing through and feeling genuinely proud of herself. Life-changing doesn't feel like an exaggeration.",
    author: 'Jennifer T.',
    location: 'Mom of a 7-year-old',
    badge: null
  }, {
    initials: 'RD',
    quote: 'My son has ADHD and I was skeptical. But these activities hold his attention in a way nothing else does. He feels capable. That alone is priceless.',
    author: 'Rachel D.',
    location: 'Special Needs Mom',
    badge: 'Verified Buyer'
  }, {
    initials: 'AK',
    quote: "The best part is you don't need to plan anything. You print, pick an activity and start. Within one week I already noticed the difference.",
    author: 'Amanda K.',
    location: 'Mom of twins',
    badge: null
  }];
  return <section className="py-10 md:py-16 px-4 bg-white" data-id="element-267">
      <div className="max-w-3xl mx-auto" data-id="element-268">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-269">
          <div className="text-center mb-8 md:mb-12" data-id="element-270">
            <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-271">
              👀 What Parents Are Saying
            </h2>
            <div className="w-24 h-2 bg-yellow-400 mx-auto rounded-full" data-id="element-272"></div>
          </div>

          <div className="space-y-4 md:space-y-6" data-id="element-273">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-5 md:p-8 rounded-2xl border border-gray-200 shadow-sm relative" data-id="element-274">
                <div className="flex items-start gap-4" data-id="element-275">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-276">
                    <span className="text-white font-black text-sm md:text-base" data-id="element-277">
                      {t.initials}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-278">
                    <div className="flex items-center gap-2 mb-2" data-id="element-279">
                      <div className="flex text-yellow-400" data-id="element-280">
                        {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-281">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-282" />
                          </svg>)}
                      </div>
                      {t.badge && <span className="bg-yellow-400 text-black text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase" data-id="element-283">
                          {t.badge}
                        </span>}
                    </div>
                    <p className="text-base md:text-xl font-bold text-gray-800 mb-3 italic leading-relaxed" data-id="element-284">
                      "{t.quote}"
                    </p>
                    <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-285">
                      {t.author}
                    </p>
                    <p className="text-gray-500 text-xs md:text-sm font-medium" data-id="element-286">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}